export default "__VITE_ASSET__1e6abec6__"